export const API_URL = "https://my-json-server.typicode.com/rizaardiansyah/db-kulineran-app"